import { render, staticRenderFns } from "./JumpToTicketButton.vue?vue&type=template&id=4930a9e5"
import script from "./JumpToTicketButton.vue?vue&type=script&lang=js"
export * from "./JumpToTicketButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports